import Grid from "@mui/material/Grid";
import { MenuInterface } from "../../../types";
import styles from "./styles";
import useStyles from "@hooks/useStyle";
import MenuItem from "@components/MenuItem/MenuItem";
import { useLocation } from "react-router-dom";

const AppMenu = (props: { menu: MenuInterface[] }) => {
	const { classes, cx } = useStyles(styles) as any;
	const { menu } = props;
	const location = useLocation();

	return (
		<Grid container className={cx(classes.borderLeftSeparator, classes.menuContainer)} alignItems="center">
			{menu.map((menuItem) => {
				return (
					<Grid
						className={cx(
							classes.menuItem,
							location.pathname === menuItem.path ? classes.primaryColor : classes.colorDarkGrey,
							classes.cursorPointer
						)}
						item
						key={menuItem.menuLabel}
					>
						<MenuItem subMenu={menuItem} />
					</Grid>
				);
			})}
		</Grid>
	);
};

export default AppMenu;
